import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=aa789a24&scoped=true&"
import script from "./AccountView.vue?vue&type=script&lang=js&"
export * from "./AccountView.vue?vue&type=script&lang=js&"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=aa789a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa789a24",
  null
  
)

export default component.exports